// @ts-nocheck
import React from 'react'
import { CircularProgress, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Identifier, Record, useGetList } from 'react-admin'

import { IInputProps } from 'src/types'
import { Entity } from '@obvious.tech/constellation/Entity'

interface ISelectInputProps {
  [key: string]: any
  loading: boolean
  property: IProperty
  choices: Record[]
  optionText: string
  onChange: (newValue: Identifier[]) => void
  value: Array<Record | Identifier> | null
  name: string
}

const SelectInput = ({
  choices,
  optionText,
  loading,
  onChange,
  value,
  property,
  name,
  classes,
  ...props
}: ISelectInputProps): JSX.Element => {
  const choice =
    choices?.filter(choice =>
      window.isNullish(value) ? false : value.includes(choice.id),
    ) ?? null

  return (
    <Autocomplete
      className={classes}
      {...props}
      disabled={property.readOnly || loading}
      options={choices}
      multiple
      onChange={(e, newValues) => {
        onChange(
          !window.isNullish(newValues)
            ? newValues.map(newValue => newValue.id)
            : [],
        )
      }}
      loading={loading}
      fullWidth
      ChipProps={
        property.readOnly
          ? {
              onDelete: undefined,
            }
          : undefined
      }
      loadingText='Loading...'
      getOptionLabel={option => {
        return option[optionText] ?? option.id
      }}
      getOptionSelected={(option, value) => {
        if (!window.isNullish(value) && typeof value === 'object') {
          if (window.isNullish(option.id)) return false

          return !window.isNullish(value.id) && option.id === value.id
        }
        return option.id === value
      }}
      defaultValue={[]}
      value={choice}
      id='disable-close-on-select'
      renderInput={params => (
        <TextField
          {...params}
          label={property.displayedName ?? name}
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress
                    color='inherit'
                    size={20}
                  />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}

const ReferencedArrayInput = ({
  property,
  name,
  record,
  onChange,
  value,
  classes,
}: IInputProps<string[]>): JSX.Element => {
  const targetLabelKeyPath = property.reference?.targetLabelKeyPath ?? 'id'
  const { data, loading } = useGetList(
    Entity.getResource(property.reference?.target),
    {},
    {
      field: targetLabelKeyPath,
      order: 'ASC',
    },
    {
      [targetLabelKeyPath]: '',
    },
  )

  return (
    <SelectInput
      classes={classes}
      choices={window.isNullish(data) ? [] : Object.values(data)}
      property={property}
      optionText={targetLabelKeyPath}
      record={record}
      loading={loading}
      onChange={onChange}
      value={value}
      name={name}
    />
  )
}

export default ReferencedArrayInput
